import React from 'react';
import { useTranslation } from 'react-i18next';
import '../style/Volunteers.css';
import RazMatalon from '../teamPics/RazMatalon.svg';
import OsnatMatalon from '../teamPics/OsnatMatalon.svg';
import IdithEden from '../teamPics/IdithEden.svg';
import AwitalYifrah from '../teamPics/AwitalYifrah.svg';
import ArielKotzer from '../teamPics/ArielKotzer.svg';
import GiladLuz from '../teamPics/GiladLuz.svg';
import IsabelleSchlisser from '../teamPics/IsabelleSchlisser.svg';
import VictoriaKats from '../teamPics/VictoriaKats.svg';
import DaryaNikhamov from '../teamPics/DaryaNikhamov.svg';
import TomerTourgeman from '../teamPics/TomerTourgeman.svg';
import DaniellKari from '../teamPics/DaniellKari.svg';
import ZahiFish from '../teamPics/ZahiFish.svg';
import HadasHanan from '../teamPics/HadasHanan.svg';
import MorGazith from '../teamPics/MorGazith.svg';
import AnatGretz from '../teamPics/AnatGretz.svg';
import TamarKalir from '../teamPics/TamarKalir.svg';
import OfriShani from '../teamPics/OfriShani.svg';
import DaniellaBabayev from '../teamPics/DaniellaBabayev.svg';
import AdiBlum from '../teamPics/AdiBlum.svg';
import OrSolomon from '../teamPics/OrSolomon.svg';
import OrPerez from '../teamPics/OrPerez.svg';
import SharonEden from '../teamPics/SharonEden.svg';
import YanivIzardel from '../teamPics/YanivIzardel.svg';
import LiorEtgar from '../teamPics/LiorEtgar.svg';
import SharonKalimi from '../teamPics/SharonKalimi.svg';
import NetaPG from '../teamPics/NetaPG.svg';
import NoaB from '../teamPics/NoaB.svg';

const Volunteers = () => {
    const { t } = useTranslation();
    //const navigate = useNavigate();

    return (
      <div className='Volunteers'>
          <div >
              <h1>{t('volunteers.title')}</h1>
              <p>
                {t('volunteers.p1')}<br/>
                {t('volunteers.p2')} <br/>
                {t('volunteers.p3')} 
              </p>
          </div>
          <div>
              <h1>{t('volunteers.management')}</h1>
              <div className='members-container'>
                  <div>
                      <img src={RazMatalon} alt="Raz Matalon"/>
                      <div className='member-name'>{t('volunteers.membersNames.raz')}</div>
                      <div className='role'>{t('volunteers.roles.founder')}</div>
                  </div>
                  <div>
                      <img src={OsnatMatalon} alt="Osnat Matalon"/>
                      <div className='member-name'>{t('volunteers.membersNames.osnat')}</div>
                      <div className='role'>{t('volunteers.roles.founderF')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/iditheden/" target="_blank" rel="noopener noreferrer">
                          <img src={IdithEden} alt="Idith Eden" /></a><br/>
                      <div className='member-name'>{t('volunteers.membersNames.idith')}</div>
                      <div className='role'>{t('volunteers.roles.manager')}</div>
                  </div><br/>
                  <div>
                      <a href="https://www.linkedin.com/in/awital-ifrah/" target="_blank" rel="noopener noreferrer">
                          <img src={AwitalYifrah} alt="Awital Yifrah" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.awital')}</div>
                      <div className='role'>{t('volunteers.roles.projectManager')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/arielko/" target="_blank" rel="noopener noreferrer">
                          <img src={ArielKotzer} alt="Ariel Kotzer" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.ariel')}</div>
                      <div className='role'>{t('volunteers.roles.ctreativeManager')}</div>
                  </div>
              </div><br/>

              <h1>{t('volunteers.product')}</h1>
              <div className='members-container'>
                  <div>
                      <a href="https://www.linkedin.com/in/gilad-luz-826528230/" target="_blank" rel="noopener noreferrer">
                          <img src={GiladLuz} alt="Gilad Luz" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.gilad')}</div>
                      <div className='role'>{t('volunteers.roles.productManager')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/isabelle-schlisser/" target="_blank" rel="noopener noreferrer">
                          <img src={IsabelleSchlisser} alt="Isabelle Schlisser" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.isabelle')}</div>
                      <div className='role'>{t('volunteers.roles.productManagerF')}</div>
                  </div>
              </div><br/>

              <h1>{t('volunteers.design')}</h1>
              <div className='members-container'>
                  <div>
                      <a href="https://www.linkedin.com/in/victoria-kats/" target="_blank" rel="noopener noreferrer">
                          <img src={VictoriaKats} alt="Victoria Kats" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.victoria')}</div>
                      <div className='role'>{t('volunteers.roles.designTL')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/darya-nikhamov-61b2251b4/" target="_blank" rel="noopener noreferrer">
                          <img src={DaryaNikhamov} alt="Darya Nikhamov" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.darya')}</div>
                      <div className='role'>{t('volunteers.roles.designerF')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/tomertourgeman/" target="_blank" rel="noopener noreferrer">
                          <img src={TomerTourgeman} alt="Tomer Tourgeman" /></a><br/>
                      <div className='member-name'>{t('volunteers.membersNames.tomer')}</div>
                      <div className='role'>{t('volunteers.roles.designer')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/daniellekari1/" target="_blank" rel="noopener noreferrer">
                          <img src={DaniellKari} alt="Daniell Kari" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.daniell')}</div>
                      <div className='role'>{t('volunteers.roles.designerF')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/zahi-fish/" target="_blank" rel="noopener noreferrer">
                          <img src={ZahiFish} alt="Zahi Fish" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.zahi')}</div>
                      <div className='role'>{t('volunteers.roles.designer')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/hadas-hanan-94a86357/" target="_blank" rel="noopener noreferrer">
                          <img src={HadasHanan} alt="Hadas Hanan" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.hadas')}</div>
                      <div className='role'>{t('volunteers.roles.uxExpert')}</div>
                  </div>
              </div><br/>

              <h1>{t('volunteers.development')}</h1>
              <div className="members-container">
                  <div>
                      <a href="https://www.linkedin.com/in/mor-gazith-1b5ba230/" target="_blank"
                         rel="noopener noreferrer">
                          <img src={MorGazith} alt="Mor Gazith" /></a>
                      <div className="member-name">{t("volunteers.membersNames.mor")}</div>
                      <div className="role">{t("volunteers.roles.devTL")}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/anat-gretz-0b2031114/" target="_blank"
                         rel="noopener noreferrer">
                          <img src={AnatGretz} alt="Anat Gretz" /></a>
                      <div className="member-name">{t("volunteers.membersNames.anat")}</div>
                      <div className="role">{t("volunteers.roles.devF")}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/tamar-kalir/" target="_blank" rel="noopener noreferrer">
                          <img src={TamarKalir} alt="Tamar Kalir" /></a><br />
                      <div className="member-name">{t("volunteers.membersNames.tamar")}</div>
                      <div className="role">{t("volunteers.roles.devF")}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/ofri-shani-b63523123/" target="_blank"
                         rel="noopener noreferrer">
                          <img src={OfriShani} alt="Ofri Shani" /></a>
                      <div className="member-name">{t("volunteers.membersNames.ofri")}</div>
                      <div className="role">{t("volunteers.roles.devF")}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/daniella-babayev/" target="_blank"
                         rel="noopener noreferrer">
                          <img src={DaniellaBabayev} alt="Daniella Babayev" /></a>
                      <div className="member-name">{t("volunteers.membersNames.daniella")}</div>
                      <div className="role">{t("volunteers.roles.devF")}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/adi-blum-918ab646/" target="_blank"
                         rel="noopener noreferrer">
                          <img src={AdiBlum} alt="Adi Blum" /></a><br />
                      <div className="member-name">{t("volunteers.membersNames.adi")}</div>
                      <div className="role">{t("volunteers.roles.devF")}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/or-solomon/" target="_blank" rel="noopener noreferrer">
                          <img src={OrSolomon} alt="Or Solomon" /></a>
                      <div className="member-name">{t("volunteers.membersNames.orS")}</div>
                      <div className="role">{t("volunteers.roles.dev")}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/or-perez-434867101/" target="_blank"
                         rel="noopener noreferrer">
                          <img src={OrPerez} alt="Or Perez" /></a>
                      <div className="member-name">{t("volunteers.membersNames.orP")}</div>
                      <div className="role">{t("volunteers.roles.dev")}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/noa-babliki" target="_blank" rel="noopener noreferrer">
                          <img src={NoaB} alt="Noa Babliki" /></a>
                      <div className="member-name">{t("volunteers.membersNames.noab")}</div>
                      <div className="role">{t("volunteers.roles.devF")}</div>
                  </div>
                  <div style={{ clear: "both" }}> {/* New Row */}
                      <a href="https://www.linkedin.com/in/neta-palombo-grupi/" target="_blank" rel="noopener noreferrer">
                          <img src={NetaPG} alt="Neta Palombo Grupi" /></a>
                      <div className="member-name">{t("volunteers.membersNames.netapg")}</div>
                      <div className="role">{t("volunteers.roles.devF")}</div>
                  </div>
              </div>
              <br />

              <h1>{t("volunteers.consultants")}</h1>
              <div className="members-container">
                  <div>
                      <a href="https://www.linkedin.com/in/sharoneden/" target="_blank" rel="noopener noreferrer">
                          <img src={SharonEden} alt="Sharon Eden" /></a>
                      <div className="member-name">{t("volunteers.membersNames.sharonE")}</div>
                      <div className='role'>{t('volunteers.roles.consultant')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/yaniv-izardel-b2b666127/" target="_blank" rel="noopener noreferrer">
                          <img src={YanivIzardel} alt="Yaniv Izardel" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.yaniv')}</div>
                      <div className='role'>{t('volunteers.roles.lawyer')}</div>
                  </div>
                  <div>
                      <a href="https://www.linkedin.com/in/lior-etgar-4a116520/" target="_blank" rel="noopener noreferrer">
                          <img src={LiorEtgar} alt="Lior Etgar" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.lior')}</div>
                      <div className='role'>{t('volunteers.roles.lawyer')}</div><br/>
                  </div>
                  <div>
                      <a href="https://www.facebook.com/Sharon.Writing.Fun" target="_blank" rel="noopener noreferrer">
                          <img src={SharonKalimi} alt="Sharon Kalimi" /></a>
                      <div className='member-name'>{t('volunteers.membersNames.sharonK')}</div>
                      <div className='role'>{t('volunteers.roles.copywriter')}</div><br/>
                  </div>
              </div>
          </div>
      </div>
    )
};

export default Volunteers;